import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { titleForPath } from "./route-title.js";

/**
 * Side-effect-only: keeps `document.title` in sync with the active route.
 * Rendered once inside the router; returns nothing.
 */
export function RouteTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = titleForPath(pathname);
  }, [pathname]);
  return null;
}
